module.exports = {
  __depends__: [
    require(149),
    require(227),
    require(203)
  ],
  __init__: [ 'copyPaste' ],
  copyPaste: [ 'type', require(154) ]
};
